import { useEffect, useState, useRef } from "react";
import { message } from "antd";
import {
  configureMessage,
  setMessageApi,
  showMessage,
} from "../../Services/messagesServices";
import Image from "next/image";
import { useIntl } from "react-intl";
import { useLocale } from "../Context/LocaleContext";

const disconnectedIcon =
  "data:image/svg+xml;utf8,<svg width='29' height='28' viewBox='0 0 29 28' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M25.4446 4.11824L4.44463 25.1182C4.2743 25.2886 4.05026 25.3749 3.82626 25.3749C3.60226 25.3749 3.37823 25.2897 3.20789 25.1182C2.86606 24.7764 2.86606 24.2222 3.20789 23.8804L13.3125 13.7759C11.3129 13.9813 9.41925 14.7839 7.89792 16.0964C7.73225 16.2387 7.52926 16.3087 7.32626 16.3087C7.08126 16.3087 6.83755 16.2061 6.66489 16.0054C6.34872 15.6402 6.38944 15.0873 6.75461 14.7711C8.84877 12.9639 11.5379 11.9687 14.3263 11.9687C14.5829 11.9687 14.8303 11.9921 15.0799 12.0084L17.6616 9.42656C16.5661 9.17572 15.4498 9.0404 14.3263 9.0404C10.6618 9.0404 7.14076 10.3867 4.4096 12.8309C4.24276 12.9802 4.0351 13.0537 3.82626 13.0537C3.58593 13.0537 3.34667 12.9557 3.174 12.7621C2.852 12.4016 2.88243 11.8486 3.24293 11.5266C6.29493 8.79424 10.2313 7.2904 14.3263 7.2904C15.9409 7.2904 17.5381 7.53656 19.0898 7.99856L24.2079 2.8804C24.5497 2.53857 25.1039 2.53857 25.4458 2.8804C25.7864 3.22223 25.7865 3.77757 25.4446 4.11824ZM14.3263 20.9999C13.6823 20.9999 13.1596 21.5226 13.1596 22.1666C13.1596 22.8106 13.6823 23.3332 14.3263 23.3332C14.9703 23.3332 15.4929 22.8106 15.4929 22.1666C15.4929 21.5226 14.9703 20.9999 14.3263 20.9999ZM15.5314 16.7556C15.0554 16.6704 14.6017 16.9866 14.5154 17.4626C14.4302 17.9386 14.7464 18.3936 15.2212 18.4787C15.9819 18.6152 16.6981 18.9279 17.2931 19.3852C17.4517 19.5066 17.6385 19.5661 17.824 19.5661C18.0876 19.5661 18.3466 19.4482 18.5193 19.2242C18.8144 18.8404 18.741 18.2909 18.3572 17.9969C17.5429 17.3704 16.565 16.9411 15.5314 16.7556ZM19.4338 13.1541C18.994 12.9417 18.4761 13.1249 18.2638 13.5589C18.0526 13.9941 18.2345 14.5167 18.6685 14.7279C19.4303 15.0977 20.1316 15.5586 20.7546 16.0964C20.9203 16.2399 21.1233 16.3099 21.3263 16.3099C21.5713 16.3099 21.815 16.2072 21.9876 16.0066C22.3038 15.6414 22.2631 15.0884 21.8979 14.7722C21.1606 14.1352 20.331 13.5904 19.4338 13.1541ZM22.9677 9.72759C22.5536 9.47792 22.0168 9.61092 21.7672 10.0239C21.5163 10.4369 21.6495 10.9759 22.0637 11.2256C22.8255 11.6876 23.5603 12.2289 24.2463 12.8356C24.4132 12.9826 24.6198 13.0549 24.8263 13.0549C25.0678 13.0549 25.3081 12.9558 25.4819 12.7598C25.8016 12.3981 25.769 11.8451 25.4073 11.5242C24.642 10.8487 23.8217 10.2444 22.9677 9.72759Z' fill='white'/></svg>";
const connectedIcon =
  "data:image/svg+xml;utf8,<svg width='39' height='32' viewBox='0 0 39 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M23.3152 20.2762C23.7277 20.5887 23.809 21.1775 23.4965 21.59C23.3127 21.8325 23.0316 21.9613 22.7479 21.9613C22.5516 21.9613 22.3518 21.8987 22.183 21.77C20.3568 20.3837 17.6415 20.3837 15.8152 21.77C15.4052 22.0837 14.8142 22.0025 14.5017 21.59C14.1892 21.1775 14.2693 20.59 14.683 20.2762C17.1655 18.3912 20.8327 18.3912 23.3152 20.2762ZM18.9991 13.825C16.0191 13.825 13.1391 14.8913 10.8879 16.8263C10.4966 17.1638 10.4502 17.755 10.789 18.1487C11.1277 18.5425 11.7191 18.585 12.1116 18.2488C14.0216 16.6063 16.4678 15.7012 19.0003 15.7012C21.5328 15.7012 23.9778 16.6063 25.8891 18.2488C26.0666 18.4013 26.2828 18.475 26.5003 18.475C26.7641 18.475 27.0255 18.3637 27.2105 18.1487C27.5492 17.7562 27.5029 17.1638 27.1116 16.8263C24.8591 14.8913 21.9791 13.825 18.9991 13.825ZM30.8741 13.355C27.6041 10.4263 23.3879 8.8125 18.9991 8.8125C14.6104 8.8125 10.3941 10.4263 7.12412 13.355C6.73787 13.7 6.70527 14.2925 7.05027 14.6787C7.39527 15.065 7.98912 15.0963 8.37412 14.7513C11.3004 12.1313 15.0729 10.6875 18.9991 10.6875C22.9254 10.6875 26.6979 12.1313 29.6241 14.7513C29.8029 14.9113 30.0254 14.99 30.2491 14.99C30.5066 14.99 30.7617 14.885 30.948 14.6775C31.293 14.2925 31.2604 13.7 30.8741 13.355ZM18.9991 23.5C18.3091 23.5 17.7491 24.06 17.7491 24.75C17.7491 25.44 18.3091 26 18.9991 26C19.6891 26 20.2491 25.44 20.2491 24.75C20.2491 24.06 19.6891 23.5 18.9991 23.5Z' fill='%23039855'/></svg>";

const useNetworkStatus = () => {
  const intl = useIntl();
  const { locale } = useLocale();
  const [isOnline, setIsOnline] = useState(true);
  const hasInitialized = useRef(false);
  const prevStatus = useRef<boolean | null>(null);

  const showNetworkMessage = (online: boolean) => {
    const messageText = online
      ? intl.formatMessage({ id: "connected" })
      : intl.formatMessage({ id: "disconnected" });

    const messageColor = online ? "bg-green-200" : "bg-red-300";
    // const iconSrc = online
    //   ? "/assets/network/connected.svg"
    //   : "/assets/network/disconnected.svg";
    const iconSrc = online ? connectedIcon : disconnectedIcon;

    // Setting correct height every time before showing message
    configureMessage({ top: window.innerHeight - 100 });

    showMessage(
      "info",
      messageText,
      3,
      messageColor,
      <Image src={iconSrc} width={28} height={28} alt="Network status" />
    );
  };

  const updateStatus = (currentStatus: boolean) => {
    if (prevStatus.current === null) {
      setIsOnline(currentStatus);
      prevStatus.current = currentStatus;

      if (!currentStatus) {
        showNetworkMessage(false);
      }

      hasInitialized.current = true;
      return;
    }

    if (prevStatus.current !== currentStatus) {
      setIsOnline(currentStatus);
      prevStatus.current = currentStatus;
      showNetworkMessage(currentStatus);
    }
  };

  const handleNetworkChange = (online: boolean) => {
    updateStatus(online);
  };

  useEffect(() => {
    setMessageApi(message);

    // console.log("Testing123", window.innerHeight - 100)
    updateStatus(true);

    const onOnline = () => handleNetworkChange(true);
    const onOffline = () => handleNetworkChange(false);

    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);

    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, [locale]);

  return {isOnline, showMessage: showNetworkMessage};
};

export default useNetworkStatus;
